var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    y: 0.667969,
    width: 8.16667,
    height: 8.16667,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.167 2.16797C11.167 1.33954 11.8386 0.667969 12.667 0.667969H17.8337C18.6621 0.667969 19.3337 1.33954 19.3337 2.16797V7.33464C19.3337 8.16306 18.6621 8.83464 17.8337 8.83464H12.667C11.8386 8.83464 11.167 8.16306 11.167 7.33464V2.16797ZM0.666992 12.668C0.666992 11.8395 1.33857 11.168 2.16699 11.168H7.33366C8.16209 11.168 8.83366 11.8395 8.83366 12.668V17.8346C8.83366 18.6631 8.16209 19.3346 7.33366 19.3346H2.16699C1.33857 19.3346 0.666992 18.6631 0.666992 17.8346V12.668ZM12.667 11.168C11.8386 11.168 11.167 11.8395 11.167 12.668V17.8346C11.167 18.6631 11.8386 19.3346 12.667 19.3346H17.8337C18.6621 19.3346 19.3337 18.6631 19.3337 17.8346V12.668C19.3337 11.8395 18.6621 11.168 17.8337 11.168H12.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.aec351a416f6672c4c46c1180efe25a1.svg";
export { ForwardRef as ReactComponent };